import { filter, includes } from "lodash";
import { useMemo } from "react";
import {
  DimText,
  useDictionaryQuery,
} from "@/shared/services/api/graphql/generated";

function getDimTextsById(dimId: number) {
  return window.dictionary.filter(
    (term: DimText) => term?.dim_id === dimId
  ) as DimText[];
}

function getDimTextsByName(dimName: string) {
  const dim = window.dictionary.find(
    (term: DimText) => term?.type === "name" && term.text === dimName
  ) as DimText;
  if (!dim) return [];
  return getDimTextsById(dim?.dim_id!);
}

export const useDictionary = () => {
  const { data, loading } = useDictionaryQuery({
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-only",
    onCompleted: (data) => {
      // eslint-disable-next-line react-compiler/react-compiler
      window.dictionary = data?.dictionary || [];
      window.findDimTexts = (dimName: string) => getDimTextsByName(dimName);
      window.findDimTextById = (dimId: number) => getDimTextsById(dimId);
    },
  });

  const dictionary = useMemo(() => data?.dictionary || [], [data]);

  const getAllTerms = (
    termId: number,
    type: string,
    bucket?: string | null
  ) => {
    if (!dictionary.length) return [];

    return filter(dictionary, (term) => {
      const bucketMatch = bucket === undefined || term?.bucket === bucket;
      return term?.dim_id === termId && term?.type === type && bucketMatch;
    });
  };

  // Weight value is for finding terms that have the closest value std to the given weight.
  const getTerm = (termId: number, type: string, bucket?: string | null) => {
    if (!dictionary.length) return "";

    const matchingTerms = getAllTerms(termId, type, bucket);

    // Todo
    return (
      matchingTerms[0]?.text ||
      `${type} for dimension ID ${termId} not found ${
        bucket ? `(bucket ${bucket})` : ""
      }`
    );
  };

  return {
    getTerm,
    getAllTerms,
    dictionary,
    loading,
  };
};
